import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalComponent, MenuModel, ProfileInfoModel } from '@app/core/models';
import { CommonService, HighlightRow } from '@app/core/services';
import {
  GetLastUsedClient,
  GetMenus,
  GetModuleRedirectionURL,
  GetProfileInfo,
  MenuState,
  RetrieveSubscription,
  SubscriptionState,
  UpdateThemeColor,
} from '@app/core/store';

import { environment } from '@environments/environment';
import { Select, Store } from '@ngxs/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Guid } from 'guid-typescript';
import { CookieService } from 'ngx-cookie-service';
import { Observable, tap } from 'rxjs';
import * as theme from 'src/assets/json/themes.json';
import jwt_decode from 'jwt-decode';
declare const pendo: any;
declare const tinycolor: any;
export interface Color {
  name: string;
  hex: string;
  darkContrast: boolean;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {
  isSearchboxShow = false;
  scrollDirection = '';
  userName: string = '';
  userPhoto: string;
  userId?: Guid;
  userEmail?: string;
  menuData: Array<MenuModel>;
  environment = environment;
  profileInfo: ProfileInfoModel;
  isOwnerUser: boolean = true;
  // Multicolor theme
  colorSelected: any;
  singletheme: any;
  themes = JSON.parse(JSON.stringify(theme));
  colors: string[] = [
    '#6d41a1',
    '#6661b8',
    '#4461d7',
    '#a0144f',
    '#045b62',
    '#14539a',
    '#a76f05',
    '#000000',
  ];

  primaryColor: string;
  primaryColorPalette: Color[] = [];
  commonService: CommonService;
  addMenuList: Array<MenuModel>;
  searchText: string;
  helpDeskUrl = environment.helpDeskUrl;

  @Select(MenuState.getMenu)
  menuList$: Observable<Array<MenuModel>>;

  @Select(MenuState.moduleId)
  moduleId$: Observable<number>;
  subscriptionModuleList: any = [];
  appUrl = '';
  myAdminUrl: string;
  profileUrl: string;
  subscriptionPortalAppUrl = '';
  isSubscriptionPortalEnabled: boolean = false;
  subscriptionData: any;

  token: any;
  decoded: any;
  moduleNames: string = '';
  clientLimit: any;
  currentTime = new Date();

  constructor(
    private router: Router,
    private globalComponent: GlobalComponent,
    private store: Store,
    public oidcSecurityService: OidcSecurityService,
    private cookieService: CookieService,
    private highlightRow: HighlightRow,
    private injector: Injector
  ) {
    this.commonService = this.injector.get<CommonService>(CommonService);
    this.onSelectionChange(this.globalComponent.themecolor(), false);
  }

  ngOnInit(): void {
    this.bindMenu();
    if(!this.cookieService.get('clientId')){
      this.getLastUsedClient();
    }
    this.getUserProfileInfo();
    this.retrieveSubscription();

    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      try {
        this.token = token;
        if (this.token) {
          this.decoded = jwt_decode(this.token);
          this.cookieService.set('externalUserGUID', this.decoded?.ExternalUserGUID);
          this.cookieService.set('name', this.decoded?.name);
          this.cookieService.set('email', this.decoded?.email);
        }
      } catch (err) {
        // token absent/invalid - safe to ignore
        this.token = null;
        this.decoded = null;
      }
    });
  }

  getLastUsedClient(): void {
    this.store.dispatch(new GetLastUsedClient()).subscribe((res) => {
      if (res.common?.lastUsedClientDetails) {
        this.commonService.setClientId(
          res.common.lastUsedClientDetails?.id,
          res.common.lastUsedClientDetails?.name
        );
      }
    });
  }

  goToProfile(): void {
    window.location.href = 'https://account.dev.capium.co.uk/Manage';
  }

  onSearchClick(): void {
    this.isSearchboxShow = true;
    this.getUserProfileInfo();
  }

  signOutUser(): void {
    this.cookieService.deleteAll();
    this.oidcSecurityService.logoff().subscribe();
  }

  getUserProfileInfo(): void {
    this.store
      .dispatch(new GetProfileInfo())
      .pipe(
        tap((res) => {
          this.userId = res.menu.profileInfo?.id;
          this.userName = res.menu.profileInfo?.name;
          this.userEmail = res.menu.profileInfo?.email;
          this.userPhoto = res.menu.profileInfo?.imagePath;

          // If token wasn't decoded earlier, try decode now (safer after profile fetch)
          const afterTokenCheck = () => {
            // If subscriptionData already present, attempt pendo init now
            if (this.subscriptionData && this.decoded) {
              this.pendoTracking();
            }
          };

          if (!this.decoded) {
            this.oidcSecurityService.getAccessToken().subscribe((token) => {
              try {
                this.token = token;
                if (this.token) {
                  this.decoded = jwt_decode(this.token);
                  this.cookieService.set('externalUserGUID', this.decoded?.ExternalUserGUID);
                  this.cookieService.set('name', this.decoded?.name);
                  this.cookieService.set('email', this.decoded?.email);
                }
              } catch {}
              afterTokenCheck();
            });
          } else {
            afterTokenCheck();
          }
        })
      )
      .subscribe();
  }

  onSearchModule(event: any): void {
    const selectedArray: MenuModel[] = [];

    this.menuData.forEach((item) => {
      if (item.url.includes(event.currentTarget.value)) {
        selectedArray.push(item);
      }
    });

    if (event.currentTarget.value) {
      this.menuData = selectedArray;
    }
  }

  isActive(val: string): string {
    const currentUrl = this.router.url.split('/')[1];
    const newValue = val?.split('/')[1];
    if (currentUrl === newValue) {
      return 'active';
    }
    return '';
  }

  onSearchModuleSelection(event: any): void {
    this.searchText = '';
    this.bindMenu();
    this.router.navigate([`${event.option.value}`]);
  }

  bindMenu(): void {
    this.store.dispatch(new GetMenus()).subscribe((data) => {
      this.menuData = data.menu.menus;
    });
  }

  onCloseClick(): void {
    this.isSearchboxShow = false;
  }

  onMenuClick(menu: any): void {}

  onSelectionChange(event: any, isThemeColor: boolean) {
    this.colorSelected = event;
    this.primaryColor = event;
    this.computeColors(this.primaryColor);

    if (isThemeColor) {
      this.store.dispatch(new UpdateThemeColor(this.primaryColor)).subscribe();

      this.highlightRow.defaultColor.next(this.primaryColor);
    }
  }

  computeColors(hex: string): void {
    for (let index = 0; index < Object.keys(this.themes).length - 2; index++) {
      if (this.themes[index].id === hex) {
        const selectedThemeArray = this.themes[index];

        this.primaryColorPalette = [
          this.getColorObject(selectedThemeArray?.id, '500'),
          this.getColorObject(selectedThemeArray?.color50, '50'),
          this.getColorObject(selectedThemeArray?.color100, '100'),
          this.getColorObject(selectedThemeArray?.color200, '200'),
          this.getColorObject(selectedThemeArray?.color300, '300'),
        ];
      }
    }

    for (const color of this.primaryColorPalette) {
      const key = `--theme-primary-${color.name}`;
      const value = color.hex;
      document.documentElement.style.setProperty(key, value);
    }
  }

  getColorObject(value, name): Color {
    const c = tinycolor(value);
    return {
      name: name,
      hex: c.toHexString(),
      darkContrast: c.isLight(),
    };
  }

  addActive(val1: string, val2: string): string {
    if (
      this.router.url.indexOf(val1) > -1 ||
      this.router.url.indexOf(val2) > -1
    ) {
      return 'active';
    }
    return '';
  }

  redirectToHome(): void {
    window.location.replace(environment.stsServerUrl);
  }

  myAdminClick() {
    window.location.replace(this.myAdminUrl);
  }
  produdctSubscriptionClick(): void {
    if (this.isSubscriptionPortalEnabled)
      window.location.replace(this.subscriptionPortalAppUrl);
  }

  redirectToModule(subscriptionModule, event: Event): void {
    if (subscriptionModule.isDisabled) {
      this.appUrl = '';
      event.preventDefault();
    } else {
      const externalUserGUID = this.cookieService.get('externalUserGUID');
      const email = this.cookieService.get('email');
      this.store
        .dispatch(
          new GetModuleRedirectionURL(
            subscriptionModule['addonId'],
            email,
            externalUserGUID
          )
        )
        .subscribe(() => {
          this.appUrl = this.store.selectSnapshot(
            SubscriptionState.getModuleRedirectionURL
          );

          window.location.replace(this.appUrl);
        });
    }
  }
  
  retrieveSubscription(): void {
    this.store.dispatch(new RetrieveSubscription()).subscribe((res) => {
      const payload =
        res?.subscription?.retrieveSubscriptionList?.data ??
        res?.subscription?.retrieveSubscriptionList ??
        null;

      if (payload) {
        this.subscriptionData = payload;
        this.subscriptionModuleList = payload.listOfAddons ?? [];
        this.profileUrl = payload.picture;
        this.isSubscriptionPortalEnabled = payload.isSubscriptionPortalEnabled;
        this.subscriptionPortalAppUrl = this.isSubscriptionPortalEnabled
          ? payload.subscriptionPortalAppUrl
          : '';

        this.moduleNames = (this.subscriptionModuleList || [])
          .filter((addon) => addon.isDisplay && !addon.isDisabled)
          .map((addon) => addon.externalName)
          .join(', ');

        if (this.decoded) {
          this.pendoTracking();
        }

        this.subscriptionModuleList.forEach((element) => {
          if (element.externalName === 'My Admin' || element.externalName === 'My Admin') {
            this.myAdminUrl = element.appUrl ?? element?.appUrl;
          }
        });
      } else {
        this.subscriptionModuleList = [];
        this.profileUrl = '';
      }
    });
  }
  onHelpClick(): void {
    window.open(this.helpDeskUrl, '_blank');
  }

  pendoTracking() {
    try {
      if (!this.decoded) return;

      this.clientLimit = this.subscriptionData?.clientLimit ?? this.clientLimit ?? 0;

      pendo.initialize({
        visitor: {
          id: this.decoded.email,
          LoginUserName: this.decoded.name,
          Email: this.decoded.email,
          UserType:
            this.decoded.role === 'ClientOwner'
              ? 'Accountant'
              : this.decoded.role === 'ClientUser'
              ? 'Staff'
              : this.decoded.role === 'ClientUser'
              ? 'Client User'
              : '',
          IsSMEUser: this.decoded.companyType === 'Accountants' ? 'No' : 'Yes',
          IsSuperAccountant: this.decoded.role === 'ClientOwner' ? 'Yes' : 'No',
          SubscriptionType: this.subscriptionData?.subscriptionType ?? '',
          CurrentModule: this.moduleNames ? this.moduleNames : '',
          LastLogIn: this.currentTime,
          PermissionLevel:
            this.decoded.role === 'ClientOwner'
              ? 'Accountant'
              : this.decoded.role === 'ClientUser'
              ? 'Staff'
              : this.decoded.role === 'ClientUser'
              ? 'Client User'
              : '',
          ClientNumber: this.clientLimit ?? 0,
          SubscriptionAmount: this.subscriptionData?.subscriptionAmount ?? 0,
          SubscriptionExpireDate: this.subscriptionData?.expiredDate,
        },
        account: {
          id: this.decoded.ExternalUserGUID ?? this.decoded.externalUserGUID ?? '',
          LoginUserName: this.decoded.name,
          Email: this.decoded.email,
          UserType:
            this.decoded.role === 'ClientOwner'
              ? 'Accountant'
              : this.decoded.role === 'ClientUser'
              ? 'Staff'
              : this.decoded.role === 'ClientUser'
              ? 'Client User'
              : '',
          IsSMEUser: this.decoded.companyType === 'Accountants' ? 'No' : 'Yes',
          IsSuperAccountant: this.decoded.role === 'ClientOwner' ? 'Yes' : 'No',
          SubscriptionType: this.subscriptionData?.subscriptionType ?? '',
          CurrentModule: this.moduleNames ? this.moduleNames : '',
          LastLogIn: this.currentTime,
          PermissionLevel:
            this.decoded.role === 'ClientOwner'
              ? 'Accountant'
              : this.decoded.role === 'ClientUser'
              ? 'Staff'
              : this.decoded.role === 'ClientUser'
              ? 'Client User'
              : '',
          ClientNumber: this.clientLimit ?? '',
          SubscriptionAmount: this.subscriptionData?.subscriptionAmount ?? 0,
          SubscriptionExpireDate: this.subscriptionData?.expiredDate,
        },
      });
    } catch (err) {
      
    }
  }
}
